module.exports = __webpack_public_path__ + "img/locations.05a6e86a.svg";